import {routerPath} from '../../../Config';

export const FormFieldWrapperClasses = (className, inline, disabled = false, active = false, small = false) => {
    const backOffice = window.location.pathname === routerPath.listKyc,
    baseClassName = inline
        ? 'form-field-wrapper row mb-2 align-items-center form-field-wrapper-inline '
        : 'form-field-wrapper row ';
    return backOffice
    ? baseClassName + (className ? className : '') + (disabled ? ' form-field-wrapper-disabled' : '')
    : baseClassName + (className ? className : '') + (disabled ? ' form-field-wrapper-disabled' : '') + ' big-input' + (active ? ' big-input-empty' : '') + (small ? ' small-input' : '');
};